<aside class="flo-panel" role="dialog" aria-labelledby="flo-panel-title"
       [class.flo-panel--max]="flo.maximized()">
	<header class="flo-header">
		<div class="flo-header__id">
			<img class="flo-header__avatar" src="assets/images/flo/flo-avatar.webp" alt="Flô" />
			<div class="flo-header__titles">
				<strong id="flo-panel-title">Flô</strong>
				<small>assistente NR-1 • Flowing</small>
			</div>
		</div>
		<div class="flo-header__actions">
			<button class="flo-header__history" type="button" aria-label="Conversas" data-tip="Conversas"
			        [class.flo-header__btn--active]="flo.historyOpen()" (click)="toggleHistory()">
				<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
				     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
					<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
					<line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="13" x2="13" y2="13"/>
				</svg>
			</button>
			<button class="flo-header__export" type="button" (click)="onExport()"
			        [disabled]="!flo.threadId() || flo.exporting()"
			        [attr.aria-label]="flo.exporting() ? 'Exportando PDF' : 'Exportar conversa em PDF'"
			        [attr.data-tip]="flo.exporting() ? 'Exportando…' : 'Exportar PDF'">
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
				     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
					<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
					<polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
				</svg>
			</button>
			<button class="flo-header__max" type="button" (click)="flo.toggleMaximize()"
			        [attr.aria-label]="flo.maximized() ? 'Restaurar' : 'Expandir'"
			        [attr.data-tip]="flo.maximized() ? 'Restaurar' : 'Expandir'">
				<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
				     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
					<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/>
					<line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>
				</svg>
			</button>
			<button class="flo-header__close" type="button" aria-label="Minimizar" data-tip="Minimizar"
			        (click)="flo.collapse()">
				<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
				     stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
					<polyline points="6 9 12 15 18 9"/>
				</svg>
			</button>
		</div>
	</header>

	<div class="flo-content">
		@if (flo.historyOpen()) {
			<app-flo-history></app-flo-history>
		}

		<div class="flo-body" #scrollArea (scroll)="onScroll()">
			@if (flo.threadLoading()) {
				<div class="flo-skel flo-skel--user"></div>
				<div class="flo-skel flo-skel--assistant flo-skel--tall"></div>
				<div class="flo-skel flo-skel--user"></div>
				<div class="flo-skel flo-skel--assistant"></div>
			} @else {
				@for (row of rows(); track row.message.id) {
					@if (row.daySeparator) {
						<div class="flo-day"><span>{{ row.daySeparator }}</span></div>
					}
					<app-flo-message [message]="row.message" (retry)="flo.retryLastMessage()"
					                 (feedback)="onFeedback(row.message.id, $event)"
					                 [downloadingReport]="flo.reportDownloading()"
					                 (downloadReport)="downloadReport()"></app-flo-message>
				}
				@if (flo.busy() && !lastHasContent()) {
					<div class="flo-working">
						<img class="flo-working__avatar" src="assets/images/flo/flo-avatar.webp" alt="" aria-hidden="true" />
						<div class="flo-working__bubble">
							<span class="flo-working__label" role="status" aria-live="polite" aria-atomic="true">{{ workingLabel() }}</span>
							<span class="flo-dots" aria-hidden="true"><span></span><span></span><span></span></span>
						</div>
					</div>
				}
			}
		</div>

		@if (reportError() ?? flo.exportFailure()) {
			<div class="flo-report-error" role="alert">{{ reportError() ?? flo.exportFailure() }}</div>
		}

		@if (!conversationStarted() && !flo.threadLoading() && flo.pills().length) {
			<div class="flo-chips">
				@for (p of flo.pills(); track p.text) {
					<button type="button" [disabled]="flo.busy()"
					        (click)="sendPill(p.text)">{{ p.text }}</button>
				}
			</div>
		}

		<div class="flo-input">
			<form (submit)="$event.preventDefault(); submit()">
				<input #inputEl type="text" [(ngModel)]="draft" name="floDraft" [attr.maxlength]="maxChars"
				       placeholder="Pergunte algo à Flô…" [disabled]="flo.busy()" autocomplete="off" />
				<button type="submit" [disabled]="flo.busy() || !draft.trim()" title="Enviar" aria-label="Enviar">↑</button>
			</form>
			@if (draft.length >= maxChars - counterShowThreshold) {
				<div class="flo-counter" [class.flo-counter--warn]="draft.length >= maxChars - counterWarnThreshold">{{ draft.length }}/{{ maxChars }}</div>
			}
			<p class="flo-disclaimer">Respostas e orientações geradas por IA com fins informativos. Não substitui o laudo técnico de um engenheiro de segurança ou médico do trabalho.</p>
		</div>
	</div>
</aside>
